module.exports = __webpack_public_path__ + "static/media/toronto.c179fbc3.webp";